module.exports = __webpack_public_path__ + "img/yalda.a138059.png";